import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PortalProductOrder from "@/components/PortalProductOrder";
import { logError } from "@/lib/log";

export default function CustomerShop() {
  const [meCust, setMeCust] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const r = await api.get("/portal/me");
      setMeCust(r.data.customer || null);
    } catch (e) { logError("Portal customer load failed:", e); }
  }, []);
  useEffect(() => { loadMe(); }, [loadMe]);

  return (
    <div className="space-y-8 animate-fade-up" data-testid="portal-shop-page">
      <div>
        <Link to="/portal" className="inline-flex items-center gap-1 text-sm text-primary hover:underline mb-4" data-testid="portal-shop-back">
          <ArrowLeft className="w-4 h-4" /> Back to my portal
        </Link>
        <p className="overline">Catalog</p>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter mt-1">Shop products</h1>
        <p className="text-sm text-muted-foreground mt-2">
          Pumps, heaters, chemicals and more — orders are reviewed by our office before delivery.
        </p>
      </div>
      <PortalProductOrder
        locked={!!meCust?.delivery_locked}
        lockReason={meCust?.delivery_lock_reason || ""}
        showSearch
      />
    </div>
  );
}
